import * as actions from './actions';

import agent from '~/agent';
import store from '~/store';

export const initialize = () => {
	agent.request
		.get('init')
		.then(response => {
			// Check for Redirect to Primary Subdomain (202)
			if (response.status == 202 && response.data.redirectTo) {
				window.location.href = `https://${response.data.redirectTo}${process.env.DOMAIN}${window.location.pathname}${window.location.search}`;

				return;
			}

			store.dispatch(
				actions.init({
					domain: process.env.DOMAIN,
					isInitialized: true,
					hasError: false,
					errorMessage: null,
					account: response.data.account,
					brandSettings: response.data.brandSettings,
					screeningSettings: response.data.screeningSettings
				})
			);
		})
		.catch(() => {
			store.dispatch(
				actions.init({
					isInitialized: false,
					hasError: true,
					errorMessage: 'Could not initialize the application.'
				})
			);
		});
};

/**
 * API
 */
export const callApi = (promise, exclude = false) => {
	if (!exclude) {
		store.dispatch(actions.startApiCall());
	}

	promise
		.catch(error => {
			// TODO: check the status code is 401
			if (error.response.status == 401) {
				store.dispatch();
			}
		})
		.finally(() => {
			if (!exclude) {
				store.dispatch(actions.endApiCall());
			}
		});
};
